import { render, staticRenderFns } from "./detectLinks.vue?vue&type=template&id=28ae7e29&"
import script from "./detectLinks.vue?vue&type=script&lang=js&"
export * from "./detectLinks.vue?vue&type=script&lang=js&"
import style0 from "./detectLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ae7e29')) {
      api.createRecord('28ae7e29', component.options)
    } else {
      api.reload('28ae7e29', component.options)
    }
    module.hot.accept("./detectLinks.vue?vue&type=template&id=28ae7e29&", function () {
      api.rerender('28ae7e29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/detectLinks.vue"
export default component.exports